import { Link } from 'react-router-dom';
import { WebP } from '/src/components/WebP';
import { Button } from '@crazyegginc/hatch';
import classNames from 'classnames';

import { useMetric, usePermissions, useAuthContext } from '/src/hooks';
import { Modal } from '/src/contexts/modal';

import { FEATURES } from '/src/features/_global/constants';

import UpsellExportPNG from '@crazyegginc/hatch/dist/images/illustration-upsell-export.png';
import UpsellExportWebP from '@crazyegginc/hatch/dist/images/illustration-upsell-export.webp';

import { ReactComponent as UpsellIcon } from '@crazyegginc/hatch/dist/images/icon-crown-filled.svg';

export function UpsellExportJsonModal({ link, metricType, type = 'snapshots' }) {
  const trackMetric = useMetric();
  const { currentAccount, isSharing } = useAuthContext();
  const isStripeUser = Boolean(currentAccount?.useStripe);

  const permissions = usePermissions();
  const canManageBilling = permissions.can('edit', FEATURES.BILLING).allowed;
  const isTypeSnapshots = type === 'snapshots';

  return (
    <Modal dialogClassName="!w-[640px] !p-0 overflow-hidden">
      <div className="relative w-full -z-[1]">
        <div className="w-full">
          <WebP
            webp={UpsellExportWebP}
            fallback={UpsellExportPNG}
            width="320"
            height="488"
            alt={'remove branding'}
            imageClassName="w-full"
          />
        </div>
        <div className="w-full border-t border-t-mystic-500 p-[30px]">
          <h4 className="flex items-center text-xl font-semibold text-black-pearl-500 mb-2">
            <UpsellIcon
              className="text-[#fbbd33] mr-3 h-5 w-5 fill-current icon-upsell mb-0.5"
              aria-label={`upsell export json`}
            />{' '}
            {canManageBilling
              ? `Upgrade to export ${isTypeSnapshots ? 'Heatmap Reports' : 'Recordings'} to AI`
              : 'Request an upgrade to the Pro or Enterprise plan'}
          </h4>
          <div
            className={classNames('text-sm text-black-pearl-500', {
              'mb-0': isSharing,
              'mb-6': !isSharing,
            })}
          >
            {canManageBilling ? (
              <>
                <p className="mb-2">
                  Download {isTypeSnapshots ? 'heatmaps' : 'recordings'} in an AI-optimized data format, so you can ask
                  deeper questions with any LLM: ChatGPT, Gemini, Grok, and more.
                </p>
                <p>Export to AI is available on Pro and Enterprise plans.</p>
              </>
            ) : (
              <p>
                Export {isTypeSnapshots ? 'heatmaps' : 'recordings'} in a JSON format, so you can analyze the data with
                any AI tool: ChatGPT, Gemini, Grok, etc. To upgrade, contact your Account Admin{' '}
                {!isSharing && (
                  <>
                    at <span className="font-bold">{currentAccount?.ownerEmail}</span>
                  </>
                )}
                .
              </p>
            )}
          </div>
          <div className="items-start flex flex-col">
            {!canManageBilling ? (
              !isSharing ? (
                <Button className="items-start flex" component="a" href={`mailto:${currentAccount.ownerEmail}`}>
                  Contact Account Owner
                </Button>
              ) : null
            ) : (
              <Button
                className="items-start flex"
                component={Link}
                to={link}
                onMouseDown={() => trackMetric('upgrade_cta_click', metricType)}
                target={isStripeUser ? '_blank' : '_self'}
                rel={isStripeUser ? 'noopener noreferrer' : undefined}
              >
                Upgrade Now
              </Button>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
}
